(ns app.front.view.pre-consultation.create-application
  "Helpers to change workspace view when triggering a specific signal."
  (:require [app.front.process :as process]
            [app.front.view.application.phase-subs :as app-phase-subs]
            [re-frame.core-instrumented :as rf]))

(defn handle-change-view-fn [new-view]
  (fn [_ [_ target signal-vec]]
    {:dispatch [::process/signal
                target
                signal-vec
                {:on-success [::app-phase-subs/set-phase-in-view new-view]}]}))

(rf/reg-event-fx ::create-from-pre-con
  (handle-change-view-fn :view/workspace-application))

(rf/reg-event-fx ::create-archiving-phase
  (handle-change-view-fn :view/workspace-archiving))
